module.exports = __webpack_public_path__ + "static/media/data-analysis-img-2.9dc018f1.svg";